













































































































































import { Component, Vue } from 'vue-property-decorator';
import { BillableTargetReportModel, BillableTargetAppUserMonthModel, BillableTargetAppUserModel } from '@/services/api/nswag/stapiclient_generated';
import { stReportApi } from '@/services/st-api';
import TimeEntryFilterComponent from '@/components/timeentry-filter/TimeEntryFilterComponent.vue';
import SlideIn from '@/components/basic/SlideIn.vue';
import ComparisonCard from '@/views/Report/ComparisonCard.vue';

import UserSelect from '@/views/TimeEntries/UserSelect.vue';
import { DateTime } from 'luxon';
import { getHours } from '@/utlitities/helper';
import {UserStore} from '@/store/user-module';
import {sortBy} from 'lodash';

Component.registerHooks(['beforeRouteUpdate']);

@Component({
  computed: {
    DateTime() {
      return DateTime
    }
  },
  methods: { getHours },
  components: { UserSelect, ComparisonCard, SlideIn, TimeEntryFilterComponent },
})
export default class BillableTargetReport extends Vue {
  year: number = DateTime.local().year;
  loading = true;
  delayLoading = false;
  displayLast12 = false;

  public reportModel: BillableTargetReportModel = BillableTargetReportModel.fromJS({ appUserModels: [] });

  async mounted() {
    if (!(UserStore.userSettings.CanEditAccount || UserStore.userSettings.hasBillableTarget))
      this.$router.push('/');

    await this.loadData();

  }

  getColorForTargetAchievment(monthData: BillableTargetAppUserMonthModel) {
    if (!monthData.hasBillableTargetPercentage) {
      return;
    }

    if (monthData.targetAchievment < 60) {
      return 'bg-red-500 text-white';
    }

    if (monthData.targetAchievment >= 60 && monthData.targetAchievment < 95) {
      return 'bg-yellow-500 text-white';
    }

    if (monthData.targetAchievment >= 95) {
      return 'bg-green-500 text-white';
    }
  }

  getTooltip(monthData: BillableTargetAppUserMonthModel) {
    const soll = '<div class="whitespace-nowrap mr-4">Soll:</div><div>' + getHours(monthData.targetMinutes) + ' h</div>';
    const ist = '<div class="whitespace-nowrap mr-4">Ist:</div><div>' + getHours(monthData.durationMinutes) + ' h</div>';
    const ziel = '<div class="whitespace-nowrap mr-4">Ziel (verr.):</div><div>' + getHours(monthData.billableTargetMinutes) + ' h</div>';
    const istv = '<div class="whitespace-nowrap mr-4">Ist (verr.):</div><div>' + getHours(monthData.durationMinutesBillable) + ' h</div>';
    const zielpro = '<div class="whitespace-nowrap mr-4">Ziel (verr.):</div><div>' + monthData.billableTargetPercentage + ' %</div>';
    const erre = '<div class="whitespace-nowrap mr-4">Ziel %:</div><div>' + monthData.targetAchievment + ' %</div>';

    return {
      content: `<div class="grid grid-cols-2">${soll}${ist}${ziel}${istv}${zielpro}${erre}</div>`,
      isHtml: true,
    };
  }

  async changeYear(plusminus: number) {
    try {
      this.loading = true;
      this.year += plusminus;
      await this.loadData();
    } finally {
      this.loading = false;
    }
  }

  async applyFilter() {
    await this.loadData();
  }

  async loadData() {
    this.loading = true;
    this.reportModel = await stReportApi.getBillableTargetReport(this.year, this.displayLast12);
    this.sortOrder = 'desc';
    this.sortMonth = 'avg';
    this.loading = false;
  }

  sortOrder: string = 'desc';
  sortMonth: string = 'avg';

  get sortedReportModel(): BillableTargetReportModel {
    let model = this.reportModel;
    model.appUserModels = sortBy(model.appUserModels, (user) => {
      let avgData = this.sortMonth == 'avg' ?  user.monthData.filter(_=> _.isAverage)[0].targetAchievment : user.monthData.filter(_=> _.month == this.sortMonth)[0].targetAchievment;
      return avgData;
    });

    if (this.sortOrder == 'desc')
      model.appUserModels = model.appUserModels.reverse();

    return model;
  }

  sortByMonth(month: string)
  {
    if (month == this.sortMonth)
    {
      if (this.sortOrder == 'asc')
        this.sortOrder = 'desc';
      else
        this.sortOrder = 'asc'
    }

    this.sortMonth = month;
  }

  getChart(user: BillableTargetAppUserModel) {
    let data = {
      series: [
        {
          name: this.$t('Sollstunden').toString(),
          type: 'bar',
          data: user.monthData.filter(_=> !_.isAverage).map((entry) => getHours(entry.targetMinutes)),
        },
        {
          name: this.$t('Iststunden').toString(),
          type: 'bar',
          data: user.monthData.filter(_=> !_.isAverage).map((entry) => getHours(entry.durationMinutes)),
        },
        {
          name: this.$t('davon verrechenbar').toString(),
          type: 'bar',
          data: user.monthData.filter(_=> !_.isAverage).map((entry) => getHours(entry.durationMinutesBillable)),
        },
        {
          name: this.$t('Zielwert verrechenbar').toString(),
          type: 'line',
          data: user.monthData.filter(_=> !_.isAverage).map((entry) => entry.billableTargetPercentage),
        },
        {
          name: this.$t('Zielerreichung').toString(),
          type: 'line',
          data: user.monthData.filter(_=> !_.isAverage).map((entry) => entry.targetAchievment),
        },
      ],
      chartOptions: {
        chart: {
          height: 350,
        },
        colors: ['#e9a81c', '#357ebd', '#6ec06e', '#f59e0b', '#6ec06e'],
        plotOptions: {
          bar: {
            endingShapes: 'round',
            columnWidth: '70px'
          },
        },
        stroke: {
          width: [1, 2, 2, 5, 5],
          dashArray: [0, 0, 0],
        },
        dataLabels: {
          enabled: false,
        },
        labels: this.reportModel?.months?.map((entry) => {
          return this.$options.filters.formatMonthName(entry);
        }),
        xaxis: {
          type: 'string',
        },
        yaxis: [
          {
            seriesName: this.$t('Sollstunden').toString(),
            title: {
              text: this.$t('Stunden').toString(),
            },
            labels: {
              formatter: (value: any) => {
                return this.$options.filters?.formatNumber(value);
              },
            },
          },
          {
            seriesName: this.$t('Sollstunden').toString(),
            title: {
              text: this.$t('Stunden').toString(),
            },
            show: false,
            labels: {
              formatter: (value: any) => {
                return this.$options.filters?.formatNumber(value);
              },
            },
          },
          {
            seriesName: this.$t('Sollstunden').toString(),
            title: {
              text: this.$t('Stunden').toString(),
            },
            show: false,
            labels: {
              formatter: (value: any) => {
                return this.$options.filters?.formatNumber(value);
              },
            },
          },
          {
            seriesName: this.$t('Zielwert verrechenbar').toString(),
            title: {
              text: this.$t('Prozent').toString(),
            },
            opposite: true,
            show: true,
            forceNiceScale: true,
            labels: {
              formatter: (value: any) => {
                return this.$options.filters?.formatNumber(value);
              },
            },
          },
          {
            seriesName: this.$t('Zielwert verrechenbar').toString(),
            title: {
              text: this.$t('Prozent').toString(),
            },
            opposite: true,
            show: false,
            forceNiceScale: true,
            labels: {
              formatter: (value: any) => {
                return this.$options.filters?.formatNumber(value);
              },
            },
          },
        ],
      },
    };

    return data;
  }
}
